import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-iframe-modal',
  templateUrl: './iframe-modal.component.html',
  styleUrls: ['./iframe-modal.component.css']
})
export class IframeModalComponent implements OnInit, OnDestroy {

  @Input() iframeUrl: string = '';
  @Output() closed = new EventEmitter<void>();

  isLoading: boolean = true;
  private loaderTimeout?: ReturnType<typeof setTimeout>;
  constructor(private el: ElementRef<HTMLElement>) { }


  ngOnInit() {
    document.body.appendChild(this.el.nativeElement);
    document.body.style.overflow = 'hidden';
    this.loaderTimeout = setTimeout(() => {
      this.isLoading = false;
    }, 5000);
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
    this.el.nativeElement.remove();
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
    }
  }

  openInNewTab() {
    window.open(this.iframeUrl, '_blank');
    this.close();
  }

  close() {
    this.closed.emit();
  }
}